import { render, staticRenderFns } from "./QuestionPallette.vue?vue&type=template&id=076c17be&scoped=true"
import script from "./QuestionPallette.vue?vue&type=script&lang=js"
export * from "./QuestionPallette.vue?vue&type=script&lang=js"
import style0 from "./QuestionPallette.vue?vue&type=style&index=0&id=076c17be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076c17be",
  null
  
)

export default component.exports